<template>
  <div>
    <v-toolbar>
      <v-toolbar-title>App layout management</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn dark color="indigo" @click="dialogCreate = true">
        <v-icon left>mdi-plus</v-icon>
        New app layout
      </v-btn>
    </v-toolbar>

    <v-sheet class="mt-5 pa-5" tile>
      <app-layouts
        @edit="editedAppLayout"
        @delete="deletedAppLayout"
      ></app-layouts>
    </v-sheet>

    <v-dialog
      v-if="dialogCreate"
      v-model="dialogCreate"
      persistent
      max-width="400px"
    >
      <create
        @cancel="dialogCreate = !dialogCreate"
        @success="createdAppLayout"
      ></create>
    </v-dialog>

    <v-dialog
      v-if="dialogEdit"
      v-model="dialogEdit"
      persistent
      max-width="400px"
    >
      <edit
        :id="appLayout.id"
        @cancel="dialogEdit = !dialogEdit"
        @success="editedAppLayout"
      ></edit>
    </v-dialog>

    <v-dialog
      v-if="dialogDelete"
      v-model="dialogDelete"
      persistent
      max-width="400px"
    >
      <delete
        :id="appLayout.id"
        @cancel="dialogDelete = !dialogDelete"
        @success="deletedAppLayout"
      ></delete>
    </v-dialog>
  </div>
</template>

<script>
import AppLayouts from '@/components/app_layouts/AppLayouts';
import Create from '@/components/app_layouts/Create';
import Edit from '@/components/app_layouts/Edit';
import Delete from '@/components/app_layouts/Delete';

export default {
  name: 'AppLayoutsView',

  components: {
    AppLayouts,
    Create,
    Edit,
    Delete
  },

  data: () => ({
    dialogCreate: false,
    dialogEdit: false,
    dialogDelete: false,

    appLayout: {}
  }),

  methods: {
    createdAppLayout() {
      this.dialogCreate = !this.dialogCreate;
      this.refreshAppLayouts();
    },

    editedAppLayout(appLayout) {
      this.dialogEdit = !this.dialogEdit;
      this.appLayout = appLayout;
      this.refreshAppLayouts();
    },

    deletedAppLayout(appLayout) {
      this.dialogDelete = !this.dialogDelete;
      this.appLayout = appLayout;
      this.refreshAppLayouts();
    },

    refreshAppLayouts() {
      this.$store.dispatch('app_layout/retrieveAppLayouts').then(({ data }) => {
        this.$store.commit('app_layout/retrievedAppLayouts', data);
      });
    }
  }
};
</script>
